import * as React from "react";
const SvgController24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M20 0v20H0V0h20Zm-2 2H2v16h16V2Zm-3 4.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM13.5 3a3.5 3.5 0 1 1-3.355 4.5H4v-2h6.145A3.502 3.502 0 0 1 13.5 3Zm-7 9a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm0-2a3.502 3.502 0 0 1 3.355 2.5H16v2H9.855A3.502 3.502 0 0 1 3 13.5 3.5 3.5 0 0 1 6.5 10Z",
      clipRule: "evenodd"
    })
  );
export default SvgController24Px;
